import * as React from "react";

function Facebook2(props) {
  return (
    <svg
      width={13}
      height={24}
      viewBox="0 0 13 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.373 0.00523774L9.28914 0.000244141C5.82454 0.000244141 3.58557 2.31852 3.58557 5.90668V8.62994H0.484905C0.21697 8.62994 0 8.84916 0 9.11956V13.0653C0 13.3357 0.217218 13.5546 0.484905 13.5546H3.58557V23.5109C3.58557 23.7813 3.80254 24.0002 4.07048 24.0002H8.11596C8.3839 24.0002 8.60087 23.781 8.60087 23.5109V13.5546H12.2263C12.4942 13.5546 12.7112 13.3357 12.7112 13.0653L12.7127 9.11956C12.7127 8.98973 12.6614 8.86539 12.5707 8.7735C12.4799 8.68162 12.3562 8.62994 12.2275 8.62994H8.60087V6.3214C8.60087 5.21182 8.86287 4.64854 10.2951 4.64854L12.3725 4.64779C12.6402 4.64779 12.8571 4.42857 12.8571 4.15842V0.494611C12.8571 0.224707 12.6404 0.0057371 12.373 0.00523774Z" fill="#8A8D8F"/>
    </svg>
  );
}

export default Facebook2;
